export * from './ng4-files.service';
export * from './ng4-files-utils.service';



// WEBPACK FOOTER //
// ./src/app/shelf/Clouddata/ng4-files/services/index.ts